<template>
  <div class="page px-5">
    <page-layout>
      <h3
        v-if="this.$route.path === '/identityResources/new'"
        slot="header"
        class="my-4"
      >
        New Identity Resource
      </h3>
      <h3
        v-else
        slot="header"
        class="my-4"
      >
        Edit Identity Resource
      </h3>
      <identity-resource-detail-form />
    </page-layout>
  </div>
</template>

<script>
import PageLayout from "@/components/shared/PageLayout.vue";
import IdentityResourceDetailForm from "@/components/identityResources/IdentityResourceDetailForm.vue";
export default {
  components: {
    PageLayout,
    IdentityResourceDetailForm
  }
};
</script>
